// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"0d3f363b","268":"a9ec7870","484":"4e8740fa","551":"6b321026","683":"3c58d95c","828":"53e72aaa"}[chunkId] + ".chunk.js";
};